function Title({title}) {
  return (
    <>
      <h3>{title}</h3>
    </>
  );
}

export default Title;
